<modal-layout-right [modalTitle]="label">
    <div modalBody>
        <div [grid]="2"
             [gridColumnGap]="['16px','16px','20px','20px'][client.sizeId]"
             [gridRowGap]="['20px','20px','32px','32px'][client.sizeId]">
            @for (group of groups; track trackByGroupId($index, group)) {
            @for (product of group.products; track trackByProductId($index, product)) {
            <product-view-upsell-products-modal-item [gridColumn]="1"
                                                     [product]="product"></product-view-upsell-products-modal-item>
            }
            }
        </div>
    </div>

    <div modalFooter>
        <div class="h4 m-b m-t--4 m-t--2-s">
            {{'Total:' | translate}}
            <price [value]="total"></price>
        </div>
        <button class="button w-12"
                [attr.aria-label]="'Confirm' | translate"
                (click)="confirm()"
                type="button">
            {{'Confirm' | translate }}
        </button>
    </div>
</modal-layout-right>
